import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PostHogService {

    constructor() {
        this.init();
    }

    private init() {
        if (environment.posthog && environment.posthog.apiKey) {
            posthog.init(environment.posthog.apiKey, {
                api_host: environment.posthog.host || 'https://app.posthog.com',
                loaded: (ph) => {
                    console.log('PostHog loaded', ph);
                }
            });
        } else {
            console.warn('PostHog configuration missing');
        }
    }

    identify(userId: string, properties: any = {}) {
        posthog.identify(userId, properties);
    }

    capture(eventName: string, properties: any = {}) {
        posthog.capture(eventName, properties);
    }

    getSessionId() {
        return posthog.get_session_id();
    }
}
